import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import { HotelImage } from 'shared/api/tours/search'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ImageGallery } from 'shared/ui/image-gallery'

import s from './styles.module.scss'

interface LocationState {
  images: HotelImage[]
  title: string
}

const RADIX_BASE = 10
const DEFAULT_SLIDE_INDEX = 0

const RoomPreview = () => {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const location = useLocation()
  const previewIndex = params.get('index')
  const state = location.state as LocationState | null

  if (!state?.images?.length) {
    return (
      <div>
        <HeaderGoBack
          variant={'grey'}
          title="Превью номера"
          buttonWhite
        />
        <div className={s.empty}>
          <p>{t('tours_block.empty_images')}</p>
        </div>
      </div>
    )
  }

  return (
    <div>
      <HeaderGoBack
        variant={'grey'}
        title={state.title || t('tours_block.room_preview')}
        buttonWhite
      />
      <div className={s.content}>
        <ImageGallery
          initialSlideIndex={
            previewIndex
              ? parseInt(previewIndex, RADIX_BASE)
              : DEFAULT_SLIDE_INDEX
          }
          images={state.images.map((i) => i.src)}
        />
      </div>
    </div>
  )
}

export default RoomPreview
